export default {"src":"/_next/static/media/jd-AnkleLength.8d17cefd.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};